import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// Holds a destination DynamicComponent id, so the key is in both dependency walkers
// (helpers/component-reference-keys.js and Models/Studio/DcDependencyWalker.php).
export default class FeedLastSeenComponentId extends BaseOption {
  static compiledIsRaw = true;

  static userInterfaceComponent = {
    label: "Unread line component",
    component: inspectorTools.REFERENCED_COMPONENT_PICKER,
    descriptionMessage: "Shown above the first row the viewer has not seen yet.",
    props: {
      candidateSource: "authored",
      showOpenButton: false,
    },
  };

  static defaultValue = 0;
}
